import { useCallback } from "react";
import { usePermissions } from "../../../lib/hooks/usePermissions";
import { useGetRole } from "../../../lib/hooks/getRole";
import USER_ROLES from "../../../types/UserRoles";

export const useCanAction = () => {
  const { hasAccessByController } = usePermissions("User");

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [role, _, me] = useGetRole();

  const canAction = useCallback(
    (recordRole: string, recordId: string, method: string): boolean => {
      if (hasAccessByController(method)) {
        if (role === USER_ROLES.SUPER_ADMIN && me.uid !== recordId) {
          return true;
        }
        if (
          role === USER_ROLES.ADMIN &&
          recordRole !== USER_ROLES.SUPER_ADMIN &&
          me.uid !== recordId
        ) {
          return true;
        }
      }

      return false;
    },
    [hasAccessByController, me, role]
  );

  return { canAction };
};
